/* OSHA STORE — known region covers + automatic featured-image fallback */
(function () {
  const COVERS = {
    US: 'https://cdn.shopify.com/s/files/1/0738/5589/3686/files/osha-psn-gift-card-us.jpg?v=1788283720',
    SA: 'https://cdn.shopify.com/s/files/1/0738/5589/3686/files/osha-psn-gift-card-saudi.jpg?v=1788283732',
    UAE: 'https://cdn.shopify.com/s/files/1/0738/5589/3686/files/osha-psn-gift-card-uae.jpg?v=1788283751',
    TR: 'https://cdn.shopify.com/s/files/1/0738/5589/3686/files/osha-psn-gift-card-turkey.jpg?v=1788283742'
  };

  function getProductFeaturedImage() {
    return document.querySelector('meta[property="og:image:secure_url"]')?.content ||
      document.querySelector('meta[property="og:image"]')?.content ||
      document.querySelector('meta[name="twitter:image"]')?.content ||
      '';
  }

  function applyGiftCover(root) {
    const base = root && root.querySelector ? root : document;
    const selector = (base.matches && base.matches('[data-osha-giftcard-selector]')) ? base : base.querySelector('[data-osha-giftcard-selector]') || document.querySelector('[data-osha-giftcard-selector]');
    if (!selector) return;

    const code = (selector.dataset.regionCode || '').toUpperCase();
    const source = COVERS[code] || getProductFeaturedImage();
    if (!source) return;

    const container = document.querySelector('.product-information__media');
    if (!container) return;

    let stage = container.querySelector('.osha-gift-product-stage');
    if (!stage) {
      stage = document.createElement('div');
      stage.className = 'osha-gift-product-stage';
      container.appendChild(stage);
    }

    Array.from(container.children).forEach(function (child) {
      if (child !== stage) child.style.display = 'none';
    });

    const title = document.querySelector('.product-details h1, .product-information h1')?.textContent?.trim() || 'PlayStation Store Gift Card';
    stage.className = 'osha-gift-product-stage osha-gift-product-stage--cover';
    stage.innerHTML = '';

    const image = document.createElement('img');
    image.className = 'osha-gift-cover-image';
    image.src = source;
    image.alt = title;
    image.loading = 'eager';
    image.decoding = 'async';
    stage.appendChild(image);

    container.dataset.oshaGiftMediaReady = 'true';
    container.dataset.oshaMediaReady = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyGiftCover(document); }, { once: true });
  } else {
    applyGiftCover(document);
  }
  document.addEventListener('shopify:section:load', function (event) { applyGiftCover(event.target); });
})();
